exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ribbon-bottom{border-bottom:1px solid #e6e6e6}.ribbon-bottom .ribbon-bottom{width:50px;height:15px}.page-header{display:inline-block;position:relative}.wrapper{max-width:980px;margin:0 auto;background-color:#fff}.ro-text{display:flex;margin-left:50%;height:7rem;align-content:stretch;margin-bottom:2rem;position:relative}.ro-text:before{content:\"\";position:absolute;width:4rem;background:#fff;left:-2rem;height:100%}.page-footer{height:0;max-width:980px;margin:0 auto;background:#fff;position:relative}.page-footer:before{content:\"\";position:absolute;width:4rem;background:#fff;left:-2rem;height:4rem;bottom:0;margin-left:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77306b88","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 703
// module chunks = 0